import { Theme, Grid, Paper, Container } from '@mui/material';
import { createStyles, withStyles } from '@mui/styles';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { RootState } from '../../../setup';
import IMenuItem from '../../../interfaces/common/menuItem';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MainLayout from '../../common/widgets/mainLayout';
import LanguageUtils from '../../../utils/LanguageUtils';
import { exportReportCustomerTerms, fetchReportCustomerTerms, getReportCustomerTerms, isLoadingReportCustomerTrems, resetReportCustomerTerms } from '../../../reducers/reportsReducer';
import UrlConstants from '../../../constants/UrlConstants';
import Pagination from '../../../interfaces/common/pagination';
import Paging from '../../../interfaces/common/paging';
import { GridColumnVisibilityModel, GridSortDirection, GridSortItem, GridSortModel } from '@mui/x-data-grid';
import PageUtils from '../../../utils/pageUtils';
import ReportCustomerTermsFilters from '../../../interfaces/filters/reportCustomerTermsFilters';
import ReportCustomerTermsFilter from './reportCustomerTermsFilter';
import ReportCustomerTermsList from './reportCustomerTermsList';
import ReportCustomerTerms from '../../../interfaces/output/ReportCustomerTerms';

interface IReportCustomerTermsProps {
    classes: any;
    exportReportCustomerTerms: any;
    isLoading: boolean;
    onChange: () => void;
    resetReportCustomerTerms: () => void;
    fetchReportCustomerTerms: any;
    reportCustomerTerms: Pagination<ReportCustomerTerms>;
}

interface IReportCustomerTermsState {
    filters: ReportCustomerTermsFilters;
    menuItem: IMenuItem;
    paging: Paging;
    sortModel: GridSortModel;
    columnVisibilityModel: GridColumnVisibilityModel;
}

const messages = {
    reportCustomerTerms: LanguageUtils.createMessage('Report customer terms'),
    downloadCSV: LanguageUtils.createMessage('Download CSV')
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
    exportReportCustomerTerms: (filters: ReportCustomerTermsFilters) => dispatch(exportReportCustomerTerms({
        filters
    })),
    fetchReportCustomerTerms: (paging: Paging, filters: ReportCustomerTermsFilters) => dispatch(fetchReportCustomerTerms({
        paging,
        filters
    })),
    resetReportCustomerTerms: () => dispatch(resetReportCustomerTerms())
});

const mapStoreToProps = (store: RootState) => ({
    isLoading: isLoadingReportCustomerTrems(store),
    reportCustomerTerms: getReportCustomerTerms(store)
});

const styles = (theme: Theme) => createStyles({
    container: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2)
    },
    paper: {
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column'
    }
});

class ReportCustomerTermsComponent extends Component<IReportCustomerTermsProps, IReportCustomerTermsState> {
    reportCustomerListRef: any;
    constructor(props: IReportCustomerTermsProps) {
        super(props);

        this.state = {
            filters: {} as ReportCustomerTermsFilters,
            menuItem: {
                id: 1,
                name: messages.reportCustomerTerms,
                icon: <FontAwesomeIcon icon="table" size="1x" transform="grow-7" />,
                isSelected: false
            },
            paging: PageUtils.getDefaultPaging([{
                field: 'id',
                sort: 'asc'
            } as GridSortItem]),
            sortModel: [{
                field: 'id',
                sort: 'asc' as GridSortDirection
            } as GridSortItem],
            columnVisibilityModel: {}
        };
    }

    componentDidMount() {
        const { fetchReportCustomerTerms } = this.props;
        const { paging, filters } = this.state;

        fetchReportCustomerTerms(paging, filters);
    }

    componentWillUnmount() {
        const { resetReportCustomerTerms } = this.props;
        resetReportCustomerTerms();
    }

    exportCSV = () => {
        const { exportReportCustomerTerms } = this.props;
        const { filters } = this.state;

        exportReportCustomerTerms(filters);
    }

    applyFilters = () => {
        const { fetchReportCustomerTerms } = this.props;
        const { paging, filters } = this.state;

        const newPaging = PageUtils.getDefaultPaging();
        const newPagination = {
            ...paging,
            page: newPaging.page
        };
        this.setState({
            paging: newPagination
        });

        fetchReportCustomerTerms(newPagination, filters);

        if(this.reportCustomerListRef !== null && this.reportCustomerListRef !== undefined &&
            this.reportCustomerListRef.current !== null && this.reportCustomerListRef.current !== undefined) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            this.reportCustomerListRef.current.resetDataGridPage();
        }
    }

    onChange = (attribute: string, value: any) => {
        const { filters, paging } = this.state;

        const newFilter = { ...filters } as ReportCustomerTermsFilters;
        (newFilter as any)[attribute] = value;

        const newPaging = PageUtils.getDefaultPaging();
        const newPagination = {
            ...paging,
            page: newPaging.page
        };

        this.setState({
            filters: newFilter,
            paging: newPagination
        });
    }

    setDefaultState = () => {
        const { fetchReportCustomerTerms } = this.props;
        const { paging } = this.state;

        const newSortModel = [{
            field: 'id',
            sort: 'asc'
        }] as GridSortModel;

        const newPaging = PageUtils.getDefaultPaging();
        const newPagination = {
            ...paging,
            page: newPaging.page,
            sort: newSortModel
        };

        const newFilters = {
        } as ReportCustomerTermsFilters;

        this.setState({
            filters: newFilters,
            paging: newPagination
        });

        fetchReportCustomerTerms(newPagination, newFilters);

        if(this.reportCustomerListRef !== null && this.reportCustomerListRef !== undefined &&
            this.reportCustomerListRef.current !== null && this.reportCustomerListRef.current !== undefined) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            this.reportCustomerListRef.current.resetDataGridPage();
        }
    }

    _onSortChange = (newModel: GridSortModel) => {
        const { fetchReportCustomerTerms } = this.props;
        const { sortModel, filters, paging } = this.state;

        if(JSON.stringify(sortModel) !== JSON.stringify(newModel)) {
            const newPaging = {
                ...paging,
                sort: newModel
            };

            this.setState({
                sortModel: newModel,
                paging: newPaging
            });

            fetchReportCustomerTerms(newPaging, filters);

        }
    }

    render() {
        const { classes, isLoading, reportCustomerTerms, fetchReportCustomerTerms } = this.props;
        const { filters, menuItem, paging, columnVisibilityModel } = this.state;

        return (
            <MainLayout menuItem={menuItem}
                routes={
                    [{
                        name: 'go to Reports',
                        url: `${UrlConstants.REPORTS}`
                    }]}
            >
                <Container maxWidth="xl" className={classes.container}>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <Paper className={classes.paper}>
                                <ReportCustomerTermsFilter
                                    actions={[{
                                        text: messages.downloadCSV,
                                        icon: 'download',
                                        onClick: this.exportCSV
                                    }]}
                                    applyFilters={this.applyFilters} setDefaultState={this.setDefaultState} filters={filters} onChange={this.onChange} />
                                <ReportCustomerTermsList
                                    rows={reportCustomerTerms} isLoading={isLoading}
                                    ref={this.reportCustomerListRef}
                                    onPageChange={(nextPage: number, nextSize: number) => {
                                        const newPage = {
                                            ...paging,
                                            page: nextPage,
                                            size: nextSize
                                        };
                                        fetchReportCustomerTerms(newPage, filters);
                                        this.setState({ paging: newPage });
                                    }}
                                    onSortModelChange={(sortModel: GridSortModel) => this._onSortChange(sortModel)}
                                    columnVisibilityModel={columnVisibilityModel}
                                    onColumnVisibilityModelChange={(newModel: GridColumnVisibilityModel) =>
                                        this.setState({
                                            columnVisibilityModel: newModel
                                        })
                                    }
                                />
                            </Paper>
                        </Grid>
                    </Grid>
                </Container>
            </MainLayout>
        );
    }
}

export default withStyles(styles)(connect(mapStoreToProps, mapDispatchToProps)(ReportCustomerTermsComponent));